import { render, staticRenderFns } from "./allRenameDiag.vue?vue&type=template&id=fa5b7368&"
import script from "./allRenameDiag.vue?vue&type=script&lang=js&"
export * from "./allRenameDiag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports